import {AxiosError} from 'axios';
import {useQuery} from 'react-query';
import {toast} from 'react-toastify';
import {getPersianErrorCode} from '../../../global/helpers/ErrorCodes/ErrorCode';
import {ErrorResponse} from '../patchDirectLoanRequest/usePatchDirectLoanRequest';
import {getDirectLoanRequest} from './getDirectLoanRequest';

const useGetDirectLoanRequest = (loanRequestGuid: string) => {
  const {data, isLoading} = useQuery({
    queryKey: ['direct-loan-request'],
    queryFn: () => getDirectLoanRequest(loanRequestGuid),

    onError: (error: AxiosError<ErrorResponse>) => {
      const errorCode = error.response?.data?.error_code;

      if (errorCode) {
        toast.error(getPersianErrorCode(errorCode));

        return;
      }

      toast.error('خطایی رخ داده است');
    },
  });

  return {data, isLoading};
};

export default useGetDirectLoanRequest;
